import { render, staticRenderFns } from "./otherService.vue?vue&type=template&id=30f6e476&"
import script from "./otherService.vue?vue&type=script&lang=js&"
export * from "./otherService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('30f6e476', component.options)
    } else {
      api.reload('30f6e476', component.options)
    }
    module.hot.accept("./otherService.vue?vue&type=template&id=30f6e476&", function () {
      api.rerender('30f6e476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/otherService.vue"
export default component.exports